import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import admindata from '../../components/admindata'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { apiRequest } from '../../store/allApi'

import { dateFormat } from '../../utils/dateTime'
const DepositVerify = () => {
  const history = useHistory()
  const [user, setUser] = useState()
  const [allDeposite, SetallDeposite] = useState()
  const baseUrl = process.env.REACT_APP_API_BASE_URL;


  //use for pagination..
  let [limit, setLimit] = useState(17700)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [refId, setRefId] = useState(0)
  const [findByStatus, setFindByStatus] = useState(0)
  const [amount, setAmount] = useState(0)
  const [searchList1, setSearchList1] = useState(0)
  const [reason, setReason] = useState(0)
  const [utr, setUtr] = useState(0)
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);
    const [startDate, setStartDate] = useState(null)
  
  //   searching handler
  const searchHandler = event => {
    let key = event.target.value

    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }
  const searchHandler1 = event => {
    let key = event.target.value
    setSearchList1(key)
  }

  const amountAdd = event => {
    let key = event.target.value
    setAmount(key)
  }
  const reasonToAdd = event => {
    let key = event.target.value
    setReason(key)
  }
  const utrToAdd = event => {
    let key = event.target.value
    setUtr(key)
  }

  const profle =async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
     try {
             const res = await apiRequest(`admin/txn/get_deposit/allmanual?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&date=${startDate}`,"GET", null,headers)
            if (res.data) {
                 setUser(res.data.admin)
           setNumberOfPages(res.data.totalPages)
           //$('table').dataTable();
            }
               } catch (e) {
                 console.log(e)
               }
               finally {
               }
  }

  const checkdeposit = (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .post(
        baseUrl + `depositupipay/response`,
        { order_id, order_token, pay_date },
        { headers }
      )
      .then(res => {
        const icon = res.data.status == 'PAID' ? 'success' : 'danger'
        const title =
          res.data.status == 'PAID'
            ? 'Deposit submited successfully'
            : 'Transaction Failed'
        profle()
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          window.location.reload()
        }
      })
  }

  const cash_free_deposit = (order_id, order_token) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .post(
        baseUrl + `deposit/response`,
        { order_id, order_token },
        { headers }
      )
      .then(res => {
        const icon = res.data.status == 'PAID' ? 'success' : 'danger'
        const title =
          res.data.status == 'PAID'
            ? 'Deposit submited successfully'
            : 'Transaction Failed'
        profle()
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          window.location.reload()
        }
      })
  }
  const phone_deposit = (order_id, order_token) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .get(baseUrl + `phonpay-request-status?txnId=${order_id}`, { headers })
      .then(res => {
        const icon = res.data.status == 'PAID' ? 'success' : 'danger'
        const title =
          res.data.status == 'PAID'
            ? 'Deposit submited successfully'
            : 'Transaction Failed'
        profle()
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          window.location.reload()
        }
      })
  }

   const verifyDeposit =async (id) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
   
       try {
          const res = await apiRequest(`admin/deposit-verified/` + id,"GET", null,headers)
         if (res.data) {
             Swal.fire({
          title: "Verify success",
          text: res.data.msg,
          icon: "success",
        });
        profle()
         }
            } catch (e) {
                if (e.response.status == 401) {
          window.location.reload()
        }
            }
            finally {
            }
   }

  const PaymanualReject = async (order_id) => {
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    const { value: manualPaymentInput } = await Swal.fire({
      title: 'Enter Reject Payment Details',
      input: 'text',
      inputPlaceholder: 'Enter Reject Msg here',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'Payment details cannot be empty!';
        }
        return null; // Valid input
      },
    });
  
    if (manualPaymentInput) {
   
         try {
            const res = await apiRequest(`userdipositupdate/${order_id}`,"POST",  { status: 'FAILED', msg: manualPaymentInput },headers)
           if (res.data) {
              const icon = res.data.status === 'PAID' ? 'success' : 'error';
          const title =
            res.data.status === 'PAID'
              ? 'Deposit submitted successfully'
              : 'Transaction Failed';
  
          Swal.fire({
            icon,
            title,
          });
          profle(); 
           }
              } catch (e) {
                    if (e.response && e.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('uData');
            localStorage.removeItem('PData');
            // Optional: Uncomment the line below to reload the page
            // window.location.reload();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'An error occurred',
              text: e.message,
            });
          }
              }
              finally {
              }
    }
  };



  // check in

const newdateFormat = e => {
    let today = new Date(e)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    return today
  }

  function daterange (s, e) {
    if (s) {
      setStartDate(s)
    }
     
    }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus, startDate])

  if (user == undefined) {
    return null
  }

  const Invoice = data => {
    const userData = { data }
    // setUser(userData);
    history.push('/invoice', { userData })
  }

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card '>
            <div className='card-body text-light table_bg'>



              <h4 className='dashboard_heading'>Deposit Verify</h4>

              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                  <option value='0'>Select Search by</option>
                  <option value='Name'>Name</option>
                  <option value='Phone'>Phone</option>
                  <option value='_id'>TxnId</option>
                  <option value='order_token'>Utr</option>
                  <option value='amount'>Amount</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
                <h5>Or</h5>
                <select
                  className='form-control col-sm-3 m-2'
                  id='findByStatus'
                  name='findByStatus'
                  onChange={searchByStatus}
                >
                  <option value='0'>Search Status</option>
                  <option value='FAILED'>FAILED</option>
                  <option value='Pending'>Pending</option>
                  {/* <option value='pending'>pending</option> */}
                  <option value='PAID'>PAID</option>
                  {/* <option value='pending'>pending</option> */}
                  <option value='checkin'>Checkin</option>
                </select>
                <select
                  className='form-control col-sm-1 m-1 bg-dark text-light'
                  id='pagelimit'
                  name='pagelimit'
                  onChange={setpageLimit}
                >
                  <option value='10'>Set limit</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='500'>500</option>
                </select>

                
                <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={startDate}   onChange={(e) => daterange(e.target.value)}
              required
            />
              </div>

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>
                      {/* <th> ID</th>
                      <th>ORDER ID</th> */}
                      <th> Phone</th>
                      <th> User</th>
                      <th> UTR</th>
                      <th> deposit_reason</th>
                      <th> ScreenShot</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> ----- </th>
                      <th> Approve By Agent / Admin </th>
                      <th> Date </th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
  {user &&
    // user.map((data, key) => {
        user?.filter(data => data.User_id?.depositVerified === "unverified" && data.User_id?.depositVerified != undefined && data?.status != "PAID" &&  data?.status != "FAILED").map((data, key) => {
      if ((pdata.depositMinLimit <= data.amount && pdata.depositMaxLimit >= data.amount) || userData.user_type == 'Admin') {

        return (
          <tr key={key}>
            <td>{key + 1}</td>

            <td>
              { userData.user_type == 'Admin' ? (
                <span className="pl-2">{data.User_id ? data.User_id.Phone : ''}</span>
              ) : (
                <span className="pl-2">{`********${data.User_id?.Phone.toString().slice(-2)}`}</span>
              )}
            </td>

            <td>
              {data.User_id && (
                <Link
                  className="btn btn-sm btn-outline-info"
                  to={`/user/view_user/${data.User_id._id}`}
                >
                   {
                                  data.User_id?.Red_zone == true ?
                                <span className="text-danger">
                                {data.User_id.Name}
                                </span>
                                :
                                <span>
                                {data.User_id.Name}
                                </span>
}
                </Link>
              )}
            </td>

            <td>
              <span style={{ color: "blue" }}>{data.order_token}</span>
            </td>

            <td>
              <span style={{ color: "blue" }}>{data.txn_msg}</span>
            </td>

            <td>
              <a href={`${baseUrl}${data?.paymentImage}`} target="_blank" rel="noopener noreferrer">
                <img
                  alt=""
                  src={`${baseUrl}${data?.paymentImage}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";
                  }}
                  className=""
                  height={600}
                />
              </a>
            </td>

            <td>{data.amount}</td>

            <td className="font-weight-bold text-success">{data.status}</td>

            <td>
  {data.User_id?.depositVerified === "unverified" ? (
    <button
      className="btn btn-danger"
      onClick={() =>
        verifyDeposit(
          data.User_id?._id
        )
      }
    >
      Verify
    </button>
  )  : (
    "Checked All"
  )}
</td>


            <td>{data?.action_by?.Name || ""}</td>
            <td>{dateFormat(data.createdAt)}</td>

            <td>
              {data.status !== "FAILED" && data.status !== "PAID" && (
                <>
                  <button
                    className="btn btn-danger mr-2"
                    onClick={() => PaymanualReject(data.order_id)}
                  >
                    Reject
                  </button>
                
                </>
              )}
            </td>
          </tr>
        );
      }
      return null;
    })}
</tbody>

                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DepositVerify
